import auth from "./middleware/auth";

export default [
  {
    path: "/admin",
    // name: "admin-home",
    component: () => import("@/views/admin"),
    children: [
      {
        path: "",
        name: "admin-home",
        component: () => import("@/views/admin/home"),
        meta: {
          middleware: [auth]
        },
      },
      {
        path: "admin/:id",
        name: "admin-user",
        component: () => import("@/views/admin/single_admin"),
        meta: {
          middleware: [auth]
        },
      },
      {
        path: "tenant/:id",
        name: "admin-tenant",
        component: () => import("@/views/admin/single_tenant"),
        meta: {
          middleware: [auth]
        },
      },
      {
        path: "tenant/permission/:id",
        name: "admin-tenant-permission",
        component: () => import("@/views/admin/single_tenant_permission"),
        meta: {
          middleware: [auth]
        },
      },
      {
        path: "roles",
        name: "admin-roles",
        component: () => import("@/views/admin/roles"),
        meta: {
          middleware: [auth]
        },
      },
      {
        path: "roles/:id",
        name: "admin-user-role",
        component: () => import("@/views/admin/user_role"),
        meta: {
          middleware: [auth]
        },
      },
      {
        path: "tenant-management",
        name: "manage-tenant",
        component: () => import("@/views/admin/tenant"),
        meta: {
          middleware: [auth]
        },
      },
      {
        path: "lesson-pool",
        name: "admin-lesson",
        component: () => import("@/views/admin/lessons"),
        meta: {
          middleware: [auth]
        },
      },
      {
        path: "resources",
        name: "admin-resources",
        component: () => import("@/views/admin/resources"),
        meta: {
          middleware: [auth]
        },
      },
      {
        path: "/admin/settings",
        name: "admin-settings",
        component: () => import("@/views/admin/settings"),
        meta: {
          middleware: [auth]
        },
      },
      {
        path: "todo",
        component: () => import("@/views/tenant/todo/"),
        meta: {
          middleware: [auth]
        },
        children: [
          {
            path: "",
            name: "admin-todo-home",
            component: () => import("@/views/admin/todo/home"),
            meta: {
              middleware: [auth]
            },
          },
          {
            path: "create",
            name: "admin-todo-create",
            component: () => import("@/views/admin/todo/create"),
            meta: {
              middleware: [auth]
            },
          },
          {
            path: "edit/:id",
            name: "admin-todo-edit",
            component: () => import("@/views/admin/todo/edit"),
            meta: {
              middleware: [auth]
            },
          },
        ],
      },
    ],
  },
];
